export const PARTNER_TRACK_CONSTANTS = {
  TITLE: "Have a bigger audience? Apply for the Partner track",
  DESCRIPTION:
    "If you run a community, audience, or network of 10+ people who'd benefit from Exly, we build a dedicated setup for you — including your own unique link per plan.",
  BUTTON_TEXT: "Apply for partner track",
  BUTTON_LINK: "https://exlyapp.com/home/refer-exly/",
  PERKS: [
    {
      ID: "branding",
      TEXT: "Marketing assets with your branding",
    },
    {
      ID: "rates",
      TEXT: "Higher commission rates",
    },
    {
      ID: "perks",
      TEXT: "Exclusive perks for your community",
    },
    {
      ID: "manager",
      TEXT: "Dedicated partner manager",
    },
    {
      ID: "co-marketing",
      TEXT: "Co-marketing opportunities",
    },
  ],

  TRUSTED_SECTION: {
    TITLE: "TRUSTED BY THE BEST",
    CREATORS: [
      {
        ID: "creator-finance-top",
        CATEGORY: "FINANCE",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c5.png",
      },
      {
        ID: "creator-pro-course",
        CATEGORY: "PRO-COURSE",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c4.png",
      },
      {
        ID: "creator-finance",
        CATEGORY: "FITNESS",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c1.png",
      },
      {
        ID: "creator-fitness-1",
        CATEGORY: "Health & wellness",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c12.png",
      },
      {
        ID: "creator-dance",
        CATEGORY: "DANCE",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c7.png",
      },
      {
        ID: "creator-fitness-2",
        CATEGORY: "FITNESS",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c13.png",
      },
      {
        ID: "creator-coaching",
        CATEGORY: "tarot reader",
        IMAGE_URL:
          "https://lpcdn.exlyapp.com/lp/static/images/home_page_v2/top_creators/c10.png",
      },
    ],
  },
};
